<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-title>Search</v-card-title>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-radio-group
                  v-model="process"
                  @change="search"
                  row
                >
                  <v-radio
                    label="EC number prediction"
                    value="ec"
                  ></v-radio>
                  <v-radio
                    label="Enzyme selection"
                    value="vv"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <template v-if="process === 'ec'">
                <v-col cols="12">
                  <v-data-table
                    :headers="tableHeadersEcProcess"
                    :items="processList"
                    show-select
                    single-select
                    v-model="searchProcess"
                    item-key="exec_date"
                  ></v-data-table>
                </v-col>
              </template>
              <template v-else-if="process === 'vv'">
                <v-col cols="12">
                  <v-data-table
                    :headers="tableHeadersVvProcess"
                    :items="processList"
                    show-select
                    single-select
                    v-model="searchProcess"
                    item-key="exec_date"
                  ></v-data-table>
                </v-col>
              </template>
            </v-row>
          </v-container>
          <v-card-actions class="d-flex justify-end">
            <v-btn @click="inqury" :disabled="btnDisabledInquiry">Inquire result</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-form>
            <v-card-title>Output</v-card-title>
            <v-container>
              <template v-if="errorLog === ''">
                <template v-if="process === 'ec'">
                  <v-data-table
                    :headers="tableHeadersEcResult"
                    :items="results"
                  ></v-data-table>
                </template>
                <template v-else-if="process === 'vv'">
                  <v-data-table
                    :headers="tableHeadersVvResult"
                    :items="results"
                  ></v-data-table>
                  <v-img
                    :src="imageUrl"
                  ></v-img>
                </template>
              </template>
              <template v-else>
                <div id="errorLog">
                  {{ this.errorLog }}
                </div>
              </template>
            </v-container>
            <v-card-actions class="d-flex justify-end">
              <template v-if="errorLog === ''">
                <v-btn @click="download" :disabled="btnDisabledDownload">Download</v-btn>
              </template>
              <template v-else>
                <v-btn @click="deleteErrorData">Delete error data</v-btn>
              </template>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import axios from 'axios';
import moment from "moment";
import router from "../router";

let instance = null;

export default {
  data: () => ({
    process: 'ec',
    tableHeadersEcProcess: [
      { text: 'Date', value: 'exec_date'},
      { text: 'Input fasta file', value: 'param_1'},
    ],
    tableHeadersVvProcess: [
      { text: 'Date', value: 'exec_date'},
      { text: 'Search file', value: 'param_2'},
      { text: 'Reference file', value: 'param_1'},
      { text: 'EC first digit', value: 'param_3'},
      { text: 'The number of sequences', value: 'param_4'},
      { text: 'n_neighbors', value: 'param_5'},
      { text: 'metric', value: 'param_6'},
    ],
    processList: [],
    searchProcess: [],
    btnDisabledInquiry: true,
    tableHeadersEcResult: [
      { text: 'name', value: 'name'},
      { text: 'EC_1d_label', value: 'EC_1d_label'},
      { text: 'EC_1d_score', value: 'EC_1d_score'},
      { text: 'EC_4d_label', value: 'EC_4d_label'},
      { text: 'EC_4d_score', value: 'EC_4d_score'},
    ],
    tableHeadersVvResult: [
      { text: 'Ranking', value: 'Ranking'},
      { text: 'name', value: 'name'},
      { text: 'Tanimoto score', value: 'Tanimoto_score'},
    ],
    results: [],
    imageUrl: '',
    errorLog: '',
    selectProcess: [],
    btnDisabledDownload: true,
  }),
  mounted: function() {
    instance = null;
    this.checkLoggedIn();
    if (instance) {
      this.search();
    }
  },
  watch: {
    searchProcess: function() {
      if (this.searchProcess.length === 0) {
        this.btnDisabledInquiry = true;
      } else {
        this.btnDisabledInquiry = false;
      }
    },
  },
  methods: {
    ...mapActions("util", ["showProgress", "hideProgress", "openSnackbar", "closeSnackbar", ]),
    // ログインチェック
    checkLoggedIn: function() {
      this.$session.start();
      if (this.$session.has("token")) {
        instance = axios.create({
          headers: {
            Authorization: "JWT " + this.$session.get('token'),
          }
        })
      } else {
        router.push("/login");
      }
    },
    // 処理リストの取得
    search: function() {
      this.showProgress();
      this.btnDisabledInquiry = true;
      const url = '/api/jobs?process_type=' + this.process + '&user=' + this.$store.state.userName;
      instance.get(url).then((response) => {
        if (response.status === 200) {
          if (this.process === 'ec') {
            this.processList = response.data.map(value => ({
              exec_date: (new Date(value.exec_date)).toLocaleString(),
              param_1: value.param_1,
              process_type: value.process_type,
              exec_date_o: value.exec_date, // 追加
            }));
          } else {
            this.processList = response.data.map(value => ({
              exec_date: (new Date(value.exec_date)).toLocaleString(),
              param_1: value.param_1,
              param_2: value.param_2,
              param_3: value.param_3,
              param_4: value.param_4,
              param_5: value.param_5,
              param_6: value.param_6,
              process_type: value.process_type,
              exec_date_o: value.exec_date, // 追加
            }));
          }
          this.searchProcess = [];
          this.results = [];
          this.imageUrl = '';
          this.errorLog = '';
          this.btnDisabledDownload = true;
          this.hideProgress();
        }
      }).catch(() => {
        this.hideProgress();
        this.openSnackbar({ text:'Unexpected error occurred.', color:'error' });
      });
    },
    // 処理結果の問い合わせ
    inqury: function() {
      this.showProgress();

      this.selectProcess = [];
      this.results = [];
      this.imageUrl = '';
      this.errorLog = '';
      this.btnDisabledDownload = true;

      const url = `/api/inqury_${this.process}`
        + '?user=' + this.$store.state.userName
        + '&exec_date=' + moment(this.searchProcess[0].exec_date_o.replace(/\+.+$/, "")).format('YYYYMMDDHHmmss'); // 変更
      instance.get(url).then((response) => {
        if (response.status === 204) {
          this.hideProgress();
          this.openSnackbar({ text:'No results exist.', color:'error' });
        } else if (response.status === 202) {
          this.hideProgress();
          this.openSnackbar({ text:'Processing.', color:'success' });
        } else if (response.status === 200) {
          if (this.process === 'ec') {
            this.results = JSON.parse(response.data.result).map(value => ({
              name: value.name,
              EC_1d_label: value.EC_1d_label,
              EC_1d_score: Number(value.EC_1d_score).toFixed(3),
              EC_4d_label: value.EC_4d_label,
              EC_4d_score: Number(value.EC_4d_score).toFixed(3),
            }));
          } else {
            this.results = JSON.parse(response.data.result).map(value => ({
              Ranking: Number(value.Ranking),
              name: value.name,
              Tanimoto_score: Number(value['Tanimoto score']).toFixed(3),
            }));
            this.imageUrl = response.data.image_url;
          }
          this.selectProcess = JSON.parse(JSON.stringify(this.searchProcess));
          this.hideProgress();
          this.btnDisabledDownload = false;
        }
      }).catch((error) => {
        const message = error.response.data.message ? error.response.data.message : 'Unexpected error occurred.';
        if (error.response.data.log) {
          this.errorLog = error.response.data.log;
          this.selectProcess = JSON.parse(JSON.stringify(this.searchProcess));
        }
        this.hideProgress();
        this.openSnackbar({ text:message, color:'error' });
      });
    },
    // ファイルダウンロード
    download: function() {
      // zipファイル作成
      const requestParam = '?process_type=' + this.selectProcess[0].process_type
        + '&user=' + this.$store.state.userName
        + '&exec_date=' + moment(this.selectProcess[0].exec_date_o.replace(/\+.+$/, "")).format('YYYYMMDDHHmmss'); // 変更
      const urlZip = '/api/zip' + requestParam;
      instance.get(urlZip).then((responseZip) => {
        if (responseZip.status === 200) {
          // zipファイルダウンロード
          const link = document.createElement('a');
          document.body.appendChild(link);
          link.href = responseZip.data.zip_url;
          link.click();
          URL.revokeObjectURL(link);
          link.parentNode.removeChild(link);
          // 不要ファイル等削除
          const urlDelete = '/api/delete' + requestParam;
          instance.get(urlDelete).then((responseDelete) => {
            if (responseDelete.status === 200) {
              this.selectProcess = [];
              this.btnDisabledDownload = true;
              this.hideProgress();
            }
          }).catch(() => {
            this.hideProgress();
            this.openSnackbar({ text:'Unexpected error occurred.', color:'error' });
          });
        }
      }).catch(() => {
        this.hideProgress();
        this.openSnackbar({ text:'Unexpected error occurred.', color:'error' });
      });
    },
    // 不要ファイル等削除
    deleteErrorData: function() {
      const requestParam = '?process_type=' + this.selectProcess[0].process_type
        + '&user=' + this.$store.state.userName
        + '&exec_date=' + moment(this.selectProcess[0].exec_date_o.replace(/\+.+$/, "")).format('YYYYMMDDHHmmss'); // 変更
      const urlDelete = '/api/delete' + requestParam;
      instance.get(urlDelete).then((responseDelete) => {
        if (responseDelete.status === 200) {
          this.selectProcess = [];
          this.btnDisabledDownload = true;
          this.hideProgress();
          this.openSnackbar({ text:'Data was deleted.', color:'success' });
        }
      }).catch(() => {
        this.hideProgress();
        this.openSnackbar({ text:'Unexpected error occurred.', color:'error' });
      });
    }
  }
};
</script>
<style scoped>
  #errorLog {
    white-space: pre-line;
  }
</style>
